
// Используем ваш токен. В продакшене он будет перекрыт значением из Vercel Environment Variables.
const BOT_TOKEN = process.env.TG_BOT_TOKEN || '8576782838:AAEER9GhswL3IfQOvSvSbAMg889qlVCJMEE';

export async function sendTelegramMessage(chatId: string, text: string): Promise<boolean> {
  if (!chatId) {
    console.warn('Telegram Message aborted: No chatId provided');
    return false;
  }
  
  if (!BOT_TOKEN) {
    console.error('Telegram Message aborted: TG_BOT_TOKEN is missing');
    return false;
  }

  try {
    const response = await fetch(`https://api.telegram.org/bot${BOT_TOKEN}/sendMessage`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        chat_id: chatId,
        text: text,
        parse_mode: 'Markdown',
      }),
    });

    if (!response.ok) {
      const errorData = await response.json();
      console.error('Failed to send TG message:', errorData);
      return false;
    }
    return true;
  } catch (err) {
    console.error('Telegram notification error:', err);
    return false;
  }
}

export const TG_NOTIFICATIONS = {
  test: (userName: string) => 
    `🔔 *Проверка связи!*\n\nПривет, ${userName}! Если вы видите это сообщение, значит ваш Telegram ID настроен верно. Теперь вы будете получать уведомления о приглашениях на кофе в Random Coffee Vietnam! ☕️`,

  inviteReceived: (inviterName: string) => 
    `☕️ *Новое приглашение!*\n\nПользователь *${inviterName}* пригласил вас на кофе. Проверьте вкладку "Встречи" на сайте.`,
  
  inviteAccepted: (partnerName: string, date: string, time: string, location: string) => 
    `✅ *Встреча подтверждена!*\n\n*${partnerName}* принял(а) ваше приглашение.\n📅 Дата: ${date}\n🕒 Время: ${time}\n📍 Место: ${location}\n\nПора обсудить детали в личке!`,
  
  inviteDeclined: (partnerName: string, reason?: string) => 
    `❌ *Приглашение отклонено*\n\nК сожалению, *${partnerName}* не сможет встретиться.${reason ? `\nПричина: _${reason}_` : ''}`
};
